import {KTSVG} from '../../../_metronic/helpers'
import {FC, useEffect, useState, forwardRef, useImperativeHandle} from 'react'

import {useAllexpensetypes, useUpdateexpenses} from '../../contextProviders/Atomqueryprovider'

import {Modal} from 'react-bootstrap'
import Select from 'react-select'
import {useSelectStyles} from '../../helpers/useSelectStyles'

import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
import relativeTime from 'dayjs/plugin/relativeTime'
import calendar from 'dayjs/plugin/calendar'
import localizedFormat from 'dayjs/plugin/localizedFormat'
import * as Yup from 'yup'
import clsx from 'clsx'
import {useFormik} from 'formik'

dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.extend(relativeTime)
dayjs.extend(calendar)
dayjs.extend(localizedFormat)

type Props = {
  expensetoupdatedata: any
  show: boolean
  stateupdatingexpense: boolean
  handleClose: () => void
  ref: any
}

const initialValues = {
  expense_id: '',
  expense_amount: '',
  user_id: '',
  date_expense_made: '',
  expense_type_id: '',
  expense_name: '',
}

const productSchema = Yup.object().shape({
  expense_id: Yup.number().required('An expense id is required'),
  expense_amount: Yup.number().required('An expense amount is required'),
  date_expense_made: Yup.string().required('A date when the expense was made is required'),
  expense_type_id: Yup.string().required('Am expense type id is required'),
  expense_name: Yup.string().required('An expense name is required'),
})

const CURRENCY_APP = process.env.REACT_APP_CURRENCY
const API_URL = process.env.REACT_APP_API_URL
const addCommas = (num: any) => {
  // Handle undefined, null, or non-numeric values
  if (num === undefined || num === null || num === '') {
    return '0'
  }
  
  // Convert to number if it's a string
  const numValue = typeof num === 'string' ? parseFloat(num) : num
  
  // Check if it's a valid number
  if (isNaN(numValue)) {
    return '0'
  }
  
  return numValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}

export const Updateexpense: FC<Props> = forwardRef((props, ref) => {
  const [updatesmade, setUpdatesmade] = useState(true)
  const [loading, setLoading] = useState(false)
  const [submittingready, setSubmittingready] = useState<boolean>(false)
  const [expensetoupdatenow, setExpensetoupdatenow] = useState<any>([])
  //customer id and payment type
  const [customer_id, setCustomer_id] = useState<any>(null)
  const [payment_type_id, setPayment_type_id] = useState<any>(null)
  const [splitpayment, setSplitpayment] = useState<any>([])
  const [jointmpesacashPayment, setJointmpesacashPayment] = useState(false)
  const [paymentstatuschange, setPaymentstatuschange] = useState<any>(null)
  const [newSetpriceMepsa, setNewSetpriceMpesa] = useState<number>(0)
  const [newSetpriceCash, setNewSetpriceCash] = useState<number>(0)
  const [submitupdate, setSubmitupdate] = useState(false)
  const [selectedDateTime, setSelectedDateTime] = useState<Date>(new Date())
  const [localTimeZone, setLocalTimeZone] = useState<string>('')

  useEffect(() => {
    setLocalTimeZone(Intl.DateTimeFormat().resolvedOptions().timeZone)
  }, [])

  const formatDateForInput = (date: Date) => {
    const pad = (n: number) => (n < 10 ? '0' + n : n)
    const year = date.getFullYear()
    const month = pad(date.getMonth() + 1)
    const day = pad(date.getDate())
    const hour = pad(date.getHours())
    const minute = pad(date.getMinutes())
    return `${year}-${month}-${day}T${hour}:${minute}`
  }


  useEffect(() => {
    if (props.expensetoupdatedata) {
      formik.setFieldValue('expense_id', props.expensetoupdatedata.expense_id)
      formik.setFieldValue('expense_amount', props.expensetoupdatedata.expense_amount.toFixed(2))
      formik.setFieldValue('user_id', props.expensetoupdatedata.user_id)
      formik.setFieldValue('expense_type_id', props.expensetoupdatedata.expense_type_id)
      formik.setFieldValue('expense_name', props.expensetoupdatedata.expense_name)
      formik.setFieldValue('date_expense_made', formatDateForInput(new Date(props.expensetoupdatedata.date_expense_made))
      )
    }
  }, [props.expensetoupdatedata])

  const {
    isLoading: expensetypeloading,
    isSuccess: expensetypesuccess,
    data: expensetypedata,
  } = useAllexpensetypes()

  const {mutateAsync: updateexpensesmutateAsync} = useUpdateexpenses(
    expensetoupdatenow
  )
  const formik = useFormik({
    initialValues,
    validationSchema: productSchema,
    validateOnBlur: true,
    onSubmit: async (values, {setStatus, setSubmitting, resetForm}) => {
      setLoading(true)

      setExpensetoupdatenow([
        {
          expense_id: values.expense_id,
          expense_amount: values.expense_amount,
          user_id: values.user_id,
          date_expense_made: values.date_expense_made,
          expense_type_id: values.expense_type_id,
          expense_name: values.expense_name,
        }
      ])

      setSubmittingready(true)
    },
  })

  useEffect(() => {
    if (submittingready && expensetoupdatenow) {
      updateexpensesmutateAsync(expensetoupdatenow, {
        onSuccess: () => {
          setLoading(false)
          formik.resetForm({})
          formik.setSubmitting(false)
          setExpensetoupdatenow({})

          setSubmittingready(false)
          props.handleClose()
        },
        onError(error, variables, context) {
          formik.setStatus('The expense type details are incorrect')
          formik.setSubmitting(false)
          setLoading(false)
        },
      })
    }
  }, [submittingready])

  let options =
    expensetypesuccess &&
    expensetypedata?.data.map((val: any, index: any) => {
      return {
        value: val.expense_type_id,
        label: val.expense_name,
      }
    })

  const handleDateTimeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const inputDate = new Date(e.target.value)
    if (!isNaN(inputDate.getTime())) {
      formik.setFieldValue('date_expense_made', formatDateForInput(inputDate))
    } else {
      formik.setFieldValue('date_expense_made', formatDateForInput(new Date()))
    }
  }

  useImperativeHandle(ref, () => ({
    Resetmodalupdatevalues() {
      
    },
  }))

  return (
    <Modal
      className='modal fade'
      id='kt_modal_dashboard'
      data-backdrop='static'
      tabIndex={-1}
      role='dialog'
      show={props.show}
      centered
      dialogClassName='modal-lg'
      aria-hidden='true'
      onHide={props.handleClose}
    >
      <div className='modal-content'>
        <div className='modal-header'>
          <h3 className='fw-bolder'>
            Update Expense
            <span className='h-10px border-gray-200 border-start mx-2'></span>
            <span className='text-muted fw-bold fs-6'>{props.expensetoupdatedata.expense_id}</span>
          </h3>

          <div
            className='btn btn-icon btn-sm btn-active-light-primary ms-2'
            onClick={props.handleClose}
          >
            <KTSVG path='/media/icons/duotune/arrows/arr061.svg' className='svg-icon-2x' />
          </div>
        </div>
        <div className='modal-body'>
          <form 
          noValidate
          id='kt_modal_add_update_expense_form'
           className='form w-100 fv-plugins-bootstrap5 fv-plugins-framework'
           onSubmit={formik.handleSubmit}
          
          >
            {/* begin::Input group */}
            <div className='row'>
              <div className='col-lg-6 fv-row mb-7'>
                {/* begin::Label */}
                <label className='required fw-bold fs-6 mb-2'>Expense Type</label>
                {/* end::Label */}

                <Select
                  styles={useSelectStyles()}
                  isLoading={expensetypeloading}
                  isClearable={true}
                  isSearchable={true}
                  placeholder={'Select expense type ...'}
                  options={
                    expensetypesuccess &&
                    expensetypedata?.data.map((x: any) => {
                      return {value: x.expense_type_id, label: x.expense_name}
                    })
                  }
                  defaultValue={{
                    value: props.expensetoupdatedata.expense_type_id,
                    label: expensetypedata?.data
                      .filter(
                        (x: any) => x.expense_type_id === props.expensetoupdatedata.expense_type_id
                      )
                      .map((x: any) => x.expense_name)[0],
                  }}
                  onChange={(selectedOption: any) =>
                    {formik.setFieldValue('expense_name', selectedOption.label)
                    formik.setFieldValue('expense_type_id', selectedOption.value)}
                  }
                />
                {formik.touched.expense_name && formik.errors.expense_name && (
                  <div className='fv-plugins-message-container'>
                    <div className='fv-help-block'>
                      <span role='alert'>{formik.errors.expense_name}</span>
                    </div>
                  </div>
                )}
              </div>

              <div className='col-lg-6 fv-row mb-7'>
                {/* begin::Label */}
                <label className='required fw-bold fs-6 mb-2'>Expense Amount ({CURRENCY_APP})</label>
                {/* end::Label */}
                <input
  
                  type='number'
                  {...formik.getFieldProps('expense_amount')}
                  className={clsx(
                    'form-control form-control-lg form-control-solid',
                    {
                      'is-invalid': formik.touched.expense_amount && formik.errors.expense_amount,
                    },
                    {
                      'is-valid': formik.touched.expense_amount && !formik.errors.expense_amount,
                    }
                  )}
                />
                {formik.touched.expense_amount && formik.errors.expense_amount && (
                  <div className='fv-plugins-message-container'>
                    <div className='fv-help-block'>
                      <span role='alert'>{formik.errors.expense_amount}</span>
                    </div>
                  </div>
                )}
              </div>
            </div>

            {/* end::Input group */}

            {/* begin::Input group */}
            <div className='row'>
              <div className='col-lg-6 fv-row mb-7'>
                {/* begin::Label */}
                <label className='required fw-bold fs-6 mb-2'>Expense ID <span className='text-primary'>(Not Updateable)</span></label>
                {/* end::Label */}

                <input
                  disabled={true}
                  style={{ backgroundColor: 'rgba(255, 192, 203, 0.2)' }}
                  type='number'
                  {...formik.getFieldProps('expense_id')}
                  className={clsx(
                    'form-control form-control-lg form-control-solid',
                    {
                      'is-invalid': formik.touched.expense_id && formik.errors.expense_id,
                    },
                    {
                      'is-valid': formik.touched.expense_id && !formik.errors.expense_id,
                    }
                  )}
                />
                {formik.touched.expense_amount && formik.errors.expense_amount && (
                  <div className='fv-plugins-message-container'>
                    <div className='fv-help-block'>
                      <span role='alert'>{formik.errors.expense_amount}</span>
                    </div>
                  </div>
                )}
              </div>

              <div className='col-lg-6 fv-row mb-7'>
                {/* begin::Label */}
                <label className='required fw-bold fs-6 mb-2'>User ID <span className='text-primary'>(Not Updateable)</span></label>
                {/* end::Label */}
                <input
                  disabled={true}
                  style={{ backgroundColor: 'rgba(255, 192, 203, 0.2)' }}
                  type='number'
                  {...formik.getFieldProps('user_id')}
                  className={clsx(
                    'form-control form-control-lg form-control-solid',
                    {
                      'is-invalid': formik.touched.user_id && formik.errors.user_id,
                    },
                    {
                      'is-valid': formik.touched.user_id && !formik.errors.user_id,
                    }
                  )}
                />
                {formik.touched.user_id && formik.errors.user_id && (
                  <div className='fv-plugins-message-container'>
                    <div className='fv-help-block'>
                      <span role='alert'>{formik.errors.user_id}</span>
                    </div>
                  </div>
                )}
              </div>
            </div>

            {/* end::Input group */}

            {/* begin::Input group */}
            <div className='row'>
              <div className='col-lg-6 fv-row mb-7'>
                {/* begin::Label */}
                <label className='required fw-bold fs-6 mb-2'>Date & Time</label>
                {/* end::Label */}

                <input
                  type='datetime-local'
                  {...formik.getFieldProps('date_expense_made')}
                  className={clsx('form-control form-control-lg form-control-solid', {
                    'is-invalid':
                      formik.touched.date_expense_made && formik.errors.date_expense_made,
                    'is-valid':
                      formik.touched.date_expense_made && !formik.errors.date_expense_made,
                  })}
                  onChange={handleDateTimeChange}
                />
                {formik.touched.date_expense_made && formik.errors.date_expense_made && (
                  <div className='fv-plugins-message-container'>
                    <div className='fv-help-block'>
                      <span role='alert'>{formik.errors.date_expense_made}</span>
                    </div>
                  </div>
                )}
              </div>

              <div className='col-lg-6 fv-row mb-7'>
                {/* begin::Label */}
                <label className='required fw-bold fs-6 mb-2'>Expense Type ID <span className='text-primary'>(Not Updateable)</span></label>
                {/* end::Label */}

                <input
                  disabled={true}
                  style={{ backgroundColor: 'rgba(255, 192, 203, 0.2)' }}
                  type='number'
                  {...formik.getFieldProps('expense_type_id')}
                  className={clsx(
                    'form-control form-control-lg form-control-solid',
                    {
                      'is-invalid': formik.touched.expense_type_id && formik.errors.expense_type_id,
                    },
                    {
                      'is-valid': formik.touched.expense_type_id && !formik.errors.expense_type_id,
                    }
                  )}
                />
                {formik.touched.expense_type_id && formik.errors.expense_type_id && (
                  <div className='fv-plugins-message-container'>
                    <div className='fv-help-block'>
                      <span role='alert'>{formik.errors.expense_type_id}</span>
                    </div>
                  </div>
                )}
              </div>
            </div>

            {/* end::Input group */}
          </form>
        </div>

        <div className='modal-footer border-0 mt-n5'>
          <button type='button' className='btn btn-light-primary' onClick={props.handleClose}>
            Cancel
          </button>

          <button
            type='submit'
            form='kt_modal_add_update_expense_form'
            className='btn btn-info'
            disabled={formik.isSubmitting || !formik.isValid || !formik.dirty}
          >
            {!loading && <span className='indicator-label'>Update Expense</span>}
            {loading && (
              <span className='indicator-progress' style={{display: 'block'}}>
                Please wait...{' '}
                <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
              </span>
            )}
          </button>
        </div>
      </div>
    </Modal>
  )
})
